import React from 'react';
import { formatTimeDurationShortRounded } from '~/modules/helpers/date';

/**
 * Cell renderer for displaying duration based on start and end times.
 * @param {Object} params - ag-Grid cell renderer params
 * @param {Object} params.data - Row data object
 * @param {number} params.data.start_time - Start time as Unix timestamp in seconds
 * @param {number} params.data.end_time - End time as Unix timestamp in seconds
 * @returns {JSX.Element} Formatted duration string or '-' if invalid
 */
export const durationCellRender = params => {
    const startTime = params.data?.start_time;
    const endTime = params.data?.end_time;

    if (!startTime || !endTime) {
        return <span>--</span>;
    }

    // Calculate duration from Unix timestamps (in seconds)
    const durationInSeconds = endTime - startTime;

    if (durationInSeconds < 0) {
        return <span>--</span>;
    }

    // Convert seconds to milliseconds for formatTimeDuration
    const durationInMilliseconds = durationInSeconds * 1000;

    const duration = formatTimeDurationShortRounded(durationInMilliseconds);

    return <span>{duration}</span>;
};
